import React, { useEffect, useState } from "react";

export default function Countdown({ target, label, danger = false, testId }) {
    const [left, setLeft] = useState(() => diff(target));
    useEffect(() => {
        const t = setInterval(() => setLeft(diff(target)), 1000);
        return () => clearInterval(t);
    }, [target]);

    function diff(d) {
        if (!d) return null;
        const ms = new Date(d).getTime() - Date.now();
        if (ms <= 0) return { d: 0, h: 0, m: 0, s: 0, done: true };
        return {
            d: Math.floor(ms / 86400000),
            h: Math.floor((ms / 3600000) % 24),
            m: Math.floor((ms / 60000) % 60),
            s: Math.floor((ms / 1000) % 60),
            done: false,
        };
    }

    if (!left) return <span className="text-muted-foreground label-mono">N/A</span>;
    const color = danger ? "text-danger" : "text-hazard";
    const cell = (v, u) => (
        <div className="flex flex-col items-center">
            <span className={`font-heading text-2xl font-bold tabular-nums ${color}`}>
                {String(v).padStart(2, "0")}
            </span>
            <span className="label-mono text-muted-foreground">{u}</span>
        </div>
    );
    return (
        <div data-testid={testId}>
            {label && <div className="label-mono text-muted-foreground mb-1">{label}</div>}
            {left.done ? (
                <span className={`font-heading text-xl font-bold ${color}`}>LIVE NOW</span>
            ) : (
                <div className="flex items-center gap-3">
                    {cell(left.d, "DAY")}{cell(left.h, "HRS")}{cell(left.m, "MIN")}{cell(left.s, "SEC")}
                </div>
            )}
        </div>
    );
}
